import { render, staticRenderFns } from "./proshopgroup.vue?vue&type=template&id=524d5839&scoped=true&"
import script from "./proshopgroup.vue?vue&type=script&lang=js&"
export * from "./proshopgroup.vue?vue&type=script&lang=js&"
import style0 from "./proshopgroup.vue?vue&type=style&index=0&id=524d5839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d5839",
  null
  
)

export default component.exports